module.exports = __webpack_public_path__ + "img/EDF_120X35.2a030acb.png";